// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XxU4","title":"styles_title__3ZZ0u"};